module.exports = __webpack_public_path__ + "static/media/applyProject2.fad3ab87.jpg";